const INITIAL_STATE = {
  esperandoSolicitacao: false,
  anexado: false,
  alerta: {}
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_ANEXOS_CAMPO_ADICIONAL_INCLUIR':
      return { ...state, esperandoSolicitacao: true, anexado: false, alerta: {} };
    case 'REQUERIMENTO_ANEXOS_CAMPO_ADICIONAL_INCLUIR_SUCESSO':
      return { ...state, esperandoSolicitacao: false, anexado: true, alerta: {} };
    case 'REQUERIMENTO_ANEXOS_CAMPO_ADICIONAL_INCLUIR_ERRO':
      return {
        ...state, esperandoSolicitacao: false, anexado: false, alerta: { message: action.payload, severity: 'error' }
      };
    case 'REQUERIMENTO_ANEXOS_CAMPO_ADICIONAL_REMOVER_SUCESSO':
      return { ...state, esperandoSolicitacao: false, anexado: false, alerta: {} };
    case 'REQUERIMENTO_ANEXOS_DOWNLOAD_ARQUIVO_INICIO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_INICIO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_AVULSO_INICIO':
      return { ...state, esperandoSolicitacao: true, alerta: {} }
    case 'REQUERIMENTO_ANEXOS_DOWNLOAD_ARQUIVO_SUCESSO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_SUCESSO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_AVULSO_FINAL':
      return { ...state, esperandoSolicitacao: false, alerta: {} }
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_AVULSO_SUCESSO':
      return { ...state, alerta: {} }
    case 'REQUERIMENTO_ANEXOS_DOWNLOAD_ARQUIVO_ERRO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_ERRO':
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_AVULSO_ERRO':
      return { ...state, esperandoSolicitacao: false, alerta: { message: action.payload, severity: 'error' } }
    default:
      return state;
  }

}  
